<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0" class="padding10">
        <el-row>
            <el-col :span="4" class="align-left">
                <item-input type="scan" v-model="bloodno" placeholder="请扫码/输入血袋号" :autofocus="true"  ref="scan-code"
                    @input="scanblood"></item-input>
            </el-col>
            <el-col :span="12" :offset="8" class="align-right">
                <el-link type="warning" size="mini" class="margin-right10" @click="loadAdverseReactions">不良反应</el-link>
                <el-button type="primary" size="mini" @click="loadNewBloodApply">申请输血</el-button>
                <el-button type="primary" size="mini" @click="loadNewCustomUseBloodView">创建用血</el-button>
            </el-col>
        </el-row>
        <div class="padding10 padding-none-h">
            <el-collapse v-model="activeName" v-if="bloodApplies.length > 0">
                <el-collapse-item :name="item.id" v-for="item in bloodApplies" :key="item.id">
                    <el-row slot="title" class="align-left width-p100">
                        <el-col :span="2" class="padding10 padding-none-v"
                            ><b>{{ item.patient_name }}</b></el-col
                        >
                        <el-col :span="4" class="padding5 padding-none-v fg-danger">
                            申请血型:<b>{{ `${item.blood_type}(${item.blood_type_rh || '--'})` }}</b>
                            <el-tag type="warning" size="mini" v-if="item.enum_use_blood_type">{{ item.use_blood_type }}</el-tag>
                        </el-col>
                        <el-col :span="13">
                            &nbsp;&nbsp;
                            <span class="fg-info"
                                >申请人：<span>{{ item.modifier }}</span></span
                            >
                            &nbsp;&nbsp;
                            <span class="fg-info">申请时间：</span>
                            <text-formatter type="datetime" v-model="item.apply_date" class="fg-info"></text-formatter>
                            &nbsp;&nbsp;
                            <span class="fg-info"
                                >状态：<span>{{ item.blood_status }}</span></span
                            >
                            &nbsp;&nbsp;
                            <span class="fg-info"
                                >原因：<span>{{ item.use_blood_reason }}</span></span
                            >
                        </el-col>
                        <el-col :span="5" class="align-right">
                            <span class="cus-button fg-primary el-icon-edit-outline" v-if="item.enum_blood_status == 0" @click.stop="loadEditBloodApply(item.id)"></span>
                            <span class="cus-button fg-primary el-icon-upload2" v-if="item.enum_blood_status == 0" @click.stop="submitBloodApply(item)"></span>
                            <PrintButton :docno="$root.DOCUMENT.SX010" :surgeryId="surgeryId" :extraParams="{ objId: item.id }"></PrintButton>
                            <span class="el-icon-delete cus-button fg-danger" v-if="item.enum_blood_status == 0" @click.stop="deleteBloodApply(item.id)"></span>
                        </el-col>
                    </el-row>
                    <list-view :columns="useBloodListColumns" :datalist="item.usedblood || []" @extrabutton-click="ExtraButtonClick($event, 1)"></list-view>
                    <!-- {{item}} -->
                </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="activeName2" v-if="customUsedBlood.length != 0">
                <el-collapse-item name="-1">
                    <el-row slot="title" class="align-left width-p100">
                        <el-col :xl="2" :md="6" class="padding10 padding-none-v"><b>非申请用血</b></el-col>
                        <el-col :span="3" class="padding5 padding-none-v fg-danger">
                            患者血型:<b>{{ `${(this.surgeryInfo && this.surgeryInfo.visit_info.blood_type) || '--'}(${(this.surgeryInfo && this.surgeryInfo.visit_info.rh_blood_type) || '--'})` }}</b>
                        </el-col>
                    </el-row>
                    <list-view :columns="CustomUseBloodListColumns" :datalist="customUsedBlood" @extrabutton-click="ExtraButtonClick($event, 2)"></list-view>
                </el-collapse-item>
            </el-collapse>
            <p v-else-if="customUsedBlood.length === 0 && bloodApplies.length === 0" class="no-surgery">暂无输血记录</p>
        </div>

        <cus-dialog title="不良反应" :visible.sync="adverse.dialogFormVisible" width="60%" @confirm="saveAdverseReactionsDocument" class="dialog-adverse">
            <el-row>
                <el-col :span="24" class="align-left">
                    <span :class="this.adverse_record && this.adverse_record.id ? 'el-icon-check' : ''" class="fg-primary"></span>
                    <span class="fg-info padding-left20">记录人：</span>{{ (this.adverse_record && this.adverse_record.modifier) || '--' }} <span class="fg-info padding-left20">记录时间：</span
                    >{{ (this.adverse_record && this.adverse_record.modify_date && this.$moment(this.adverse_record.modify_date).format('YYYY/MM/DD HH:mm:ss')) || '--' }}
                </el-col>
            </el-row>
            <DocFrame ref="doc" :docno="$root.DOCUMENT && $root.DOCUMENT.SX012" :guid="docguid" :surgeryId="surgeryId" docname="不良反应记录单" @saved="afterAdverseReactionsDocumentSaved"></DocFrame>
        </cus-dialog>
        <form-dialog
            class="form-table-h160"
            title="输血申请"
            :visible.sync="bloodapply.dialogFormVisible"
            :data="bloodapply.data"
            :columns="bloodapplyColumns"
            width="95%"
            @confirm="SaveBloodApply"
        ></form-dialog>

        <form-dialog
            title="新增用血"
            :visible.sync="customUsedblood.dialogFormVisible"
            :data="customUsedblood.data"
            :columns="customUsedbloodColumns"
            width="45%"
            @confirm="SaveCustomUsedBlood"
        ></form-dialog>
        <form-dialog
            title="核对用血"
            :visible.sync="checkbloodview.dialogFormVisible"
            :data="checkbloodview.data"
            :columns="checkUsedbloodColumns"
            width="45%"
            @confirm="SaveUsedBlood($event)"
        ></form-dialog>
        <form-dialog
            title="输血记录"
            :visible.sync="editCustomUsedBloodView.dialogFormVisible"
            :data="editCustomUsedBloodView.data"
            :columns="editCustomUsedBloodColumns"
            width="45%"
            @confirm="saveEndUsedBlood($event)"
        ></form-dialog>
        <form-dialog
            title="不输血记录"
            :visible.sync="editCustomUsedBloodView2.dialogFormVisible"
            :data="editCustomUsedBloodView2.data"
            :columns="editCustomUsedBloodColumns2"
            width="45%"
            @confirm="saveNotUsedBlood($event)"
        ></form-dialog>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `BloodApply`,
    props: {

    },
    data() {
        return {
            title: `输血`,
            surgeryId: this.$route.query.surgery_id,
            surgeryInfo: undefined,
            bloodno: ``, // 血袋号码
            activeName: undefined, //
            activeName2: `-1`,
            bloodApplies: [],
            bloodDic: [],
            docguid: ``,
            adverse_record: {},
            docbizid: undefined,
            adverse: {
                dialogFormVisible: false
            },
            bloodapply: {
                dialogFormVisible: false,
                data: {}
            },
            customUsedblood: {
                dialogFormVisible: false,
                data: {}
            },
            checkbloodview: {
                dialogFormVisible: false,
                data: {}
            },
            editCustomUsedBloodView: {
                dialogFormVisible: false,
                data: {}
            },
            editCustomUsedBloodView2: {// 不输血
                dialogFormVisible: false,
                data: {}
            },
            // openItem:[],
            customUsedBlood: [],
            openData: {}
        }
    },
    mounted() {
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadBloodDic()
        this.Init()
        this.loadUseCustom()
        this.loadSurgery()
    },
    computed: {
        ...mapGetters([`sys_enums`, `sysuser/workers_by_duty`, `currentUser`]),
        worker() {
            return this[`sysuser/workers_by_duty`]
        },
        bloodapplyColumns() {
            return [{
                type: `string`,
                prop: `patient_name`,
                label: `姓名`,
                readonly: true,
                colspan: 4
            }, {
                type: `string`,
                prop: `sex`,
                label: `性别`,
                readonly: true,
                colspan: 4
            }, {
                type: `string`,
                prop: `age`,
                label: `年龄`,
                readonly: true,
                colspan: 4
            }, {
                type: `string`,
                prop: `visit_no`,
                label: this.T(`blood_apply.visit_no`),
                readonly: true,
                colspan: 4
            }, {
                type: `string`,
                prop: `dic_opearting_ward`,
                label: `手术区 `,
                readonly: true,
                colspan: 4
            }, {
                type: `string`,
                prop: `dic_operating_room`,
                label: `手术间`,
                readonly: true,
                colspan: 4
            }, {
                type: `string`,
                prop: `diseases`,
                label: `临床诊断`,
                readonly: true,
                colspan: 24
            }, {
                type: `select`,
                prop: `enum_blood_type`,
                label: { content: `血型`, position: `top` },
                options: this.sys_enums.Enum_BloodType || [],
                colspan: 4,
                default: -1
            }, {
                type: `select`,
                prop: `enum_blood_type_rh`,
                label: { content: `Rh血型`, position: `top` },
                options: this.sys_enums.Enum_RhBloodType || [],
                colspan: 4,
                default: -1
            }, {
                type: `radio`,
                prop: `enum_use_blood_type`,
                label: { content: `输血类型`, position: `top` },
                options: this.sys_enums.Enum_UseBloodType || [],
                colspan: 4,
                config: {
                    borderd: true
                }
            }, {
                type: `itemgroup`,
                prop: `yzs`,
                label: { content: `妊娠史：`, position: `top` },
                colspan: 4,
                options: [{
                    type: `integer`,
                    prop: `y`,
                    label: `孕`,
                    width: `60`,
                    default: 0,
                    meta: this.openData,
                    readonly: (that, { row, column }) => {
                        return column.meta && column.meta.sex == `男`
                    }
                }, {
                    type: `integer`,
                    prop: `c`,
                    label: `产`,
                    width: `60`,
                    default: 0,
                    meta: this.openData,
                    readonly: (that, { row, column }) => {
                        return column.meta && column.meta.sex == `男`
                    }
                }]
            }, {
                type: `select`,
                prop: `use_blood_reason`,
                label: { content: `输血原因`, position: `top` },
                options: [{ value: `急诊抢救`, label: `急诊抢救` }, { value: `治疗备用血`, label: `治疗备用血` }, { value: `急诊手术备用血`, label: `急诊手术备用血` }, { value: `择期手术备用血`, label: `择期手术备用血` }],
                colspan: 4,
                default: `择期手术备用血`
            }, {
                type: `datetime`,
                prop: `apply_date`,
                label: { content: `申请时间`, position: `top` },
                default: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                colspan: 4
            }, {
                type: `date`,
                prop: `execute_date`,
                label: { content: `预定输血日期`, position: `top` },
                default: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                colspan: 4
            }, {
                type: `select`,
                prop: `history_blood`,
                label: { content: `既往输血史`, position: `top` },
                options: [{ value: `有`, label: `有` }, { value: `无`, label: `无` }],
                default: `无`,
                colspan: 4
            }, {
                type: `select`,
                prop: `reaction_blood`,
                label: { content: `输血反应史`, position: `top` },
                options: [{ value: `有`, label: `有` }, { value: `无`, label: `无` }],
                default: `无`,
                colspan: 4,
                readonly: (that, { row }) => {
                    return row.history_blood == `无`
                }
            }, {
                type: `string`,
                prop: `last_date`,
                label: { content: `末次输血时间`, position: `top` },
                colspan: 4,
                default: ``,
                readonly: (that, { row }) => {
                    return row.history_blood == `无`
                }
            }, {
                type: `float`,
                prop: `Hb`,
                colspan: 4,
                label: { content: `Hb（g/L）`, position: `top` }
            }, {
                type: `float`,
                prop: `HCT`,
                colspan: 4,
                label: { content: `HCT`, position: `top` }
            }, {
                type: `float`,
                prop: `PLT`,
                colspan: 4,
                label: { content: `PLT（10E9/L）`, position: `top` }
            }, {
                type: `select`,
                prop: `HBsAg`,
                label: { content: `HBsAg`, position: `top` },
                colspan: 4,
                options: [{ value: `阴性`, label: `阴性` }, { value: `阳性`, label: `阳性` }, { value: `结果未回`, label: `结果未回` }, { value: `未送检`, label: `未送检` }]
            }, {
                type: `select`,
                prop: `Anti_HCV`,
                label: { content: `Anti-HCV`, position: `top` },
                colspan: 4,
                options: [{ value: `阴性`, label: `阴性` }, { value: `阳性`, label: `阳性` }, { value: `结果未回`, label: `结果未回` }, { value: `未送检`, label: `未送检` }]
            }, {
                type: `select`,
                prop: `Anti_HV`,
                label: { content: `Anti-HIV 1/2`, position: `top` },
                colspan: 4,
                options: [{ value: `阴性`, label: `阴性` }, { value: `阳性`, label: `阳性` }, { value: `结果未回`, label: `结果未回` }, { value: `未送检`, label: `未送检` }]
            }, {
                type: `select`,
                prop: `MD`,
                label: { content: `梅毒`, position: `top` },
                colspan: 4,
                options: [{ value: `阴性`, label: `阴性` }, { value: `阳性`, label: `阳性` }, { value: `结果未回`, label: `结果未回` }, { value: `未送检`, label: `未送检` }]
            }, {
                type: `p`,
                prop: `null_1`,
                label: { content: ` `, position: `top` },
                colspan: 4
            }, {
                type: `checkboxgroup`,
                prop: `blood_p15`,
                label: { content: ` `, position: `top` },
                colspan: 24,
                options: [{
                    value: `p15_1`,
                    label: `已送检查标本，结果未回`
                }, {
                    value: `p15_2`,
                    label: `已留取检查标本，未送检`
                }]
            }, {
                type: `table`,
                prop: `application_list`,
                label: { content: ` `, position: `top` },
                placeholder: `申请血液品种及数量`,
                options: [{
                    type: `select`,
                    prop: `id`,
                    label: `血液分类`,
                    // width:'200',
                    isListable: true,
                    readonly: false,
                    options: _.map(this.bloodDic, d => {
                        return {
                            value: d.id,
                            code: d.code,
                            label: d.name,
                            jianpin: d.abbr
                        }
                    }),
                    change: (that, { row }) => {
                        let r = _.find(this.bloodDic, { id: row.id })
                        row.unit = r && r.unit
                    }
                }, {
                    type: `float`,
                    prop: `quantity`,
                    label: `输血量`,
                    width: `140`,
                    readonly: false,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `unit`,
                    label: `单位`,
                    width: `60`,
                    isListable: true
                }],
                default: [],
                colspan: 24
            }]
        },
        bloodListColumnsCommon() {
            return [{
                type: `string`,
                prop: `id`,
                label: `no`,
                isKey: true
            }, {
                type: `string`,
                prop: `name`,
                label: `血液分类`,
                // width:'200',
                isListable: true
            }, {
                type: `string`,
                prop: `blood_type`,
                label: `血型`,
                width: `80`,
                isListable: true
            }, {
                type: `string`,
                prop: `quantity`,
                label: `输血量`,
                width: `80`,
                isListable: true
            }, {
                type: `string`,
                prop: `code`,
                label: `血袋号`,
                width: `140`,
                isListable: true
            }, {
                type: `datetime`,
                prop: `begin_time`,
                label: `输血开始时间`,
                width: `120`,
                isListable: true
            }, {
                type: `datetime`,
                prop: `end_time`,
                label: `输血结束时间`,
                width: `120`,
                isListable: true
            }, {
                type: `string`,
                prop: `circuit`,
                label: `执行护士`,
                width: `140`,
                isListable: true
            }, {
                type: `string`,
                prop: `anesthesiologist`,
                label: `麻醉医生`,
                width: `140`,
                isListable: true
            }, {
                type: `select`,
                prop: `enum_using_blood_status`,
                label: `状态`,
                width: `80`,
                options: this.sys_enums.BloodUsingStatus || [],
                isListable: true
            }]
        },
        useBloodListColumns() {
            return this.bloodListColumnsCommon.concat([{
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `200`,
                isListable: true,
                readonly: false,
                options: (that, { row }) => {
                    if (!row.check_time) {
                        return [{
                            class: `is-plain`,
                            label: `核对`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadCheckBloodView`,
                            permission: `default`
                        }]
                    } else if (row.enum_using_blood_status == 0) {
                        return [{
                            class: `is-plain`,
                            label: `开始`,
                            icon: ``,
                            type: `primary`,
                            emit: `startBlood`,
                            permission: `default`
                        }, {// 不输血
                            class: `is-plain`,
                            label: `不输血`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadEditCustomUsedBloodView2`,
                            permission: `default`
                        }]
                    } else if (row.enum_using_blood_status == 1) {
                        return [{
                            class: `is-plain`,
                            label: `完成`,
                            icon: ``,
                            type: `primary`,
                            emit: `endBlood`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `结束`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadEditCustomUsedBloodView`,
                            permission: `default`
                        }]
                    } else if (row.enum_using_blood_status == 5) {
                    } else {
                        return [{
                            class: `is-plain`,
                            label: `修改`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadEditCustomUsedBloodView`,
                            permission: `default`
                        }]
                    }
                }
            }])
        },
        CustomUseBloodListColumns() {
            return this.bloodListColumnsCommon.concat([{
                type: `bool`,
                prop: `is_own`,
                label: `是否自体血`,
                width: `120`,
                options: `enum_bool`,
                isListable: true
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `320`,
                isListable: true,
                readonly: false,
                options: (that, { row }) => {
                    if (!row.check_time) {
                        return [{
                            class: `is-plain`,
                            label: `核对`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadCheckBloodView`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `编辑`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadEditCustomUseBloodView`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `删除`,
                            icon: ``,
                            type: `danger`,
                            emit: `deleteCustomUseBlood`,
                            permission: `default`
                        }]
                    } else if (row.enum_using_blood_status == 0) {
                        return [{
                            class: `is-plain`,
                            label: `开始`,
                            icon: ``,
                            type: `primary`,
                            emit: `startBlood`,
                            permission: `default`
                        }, {// 不输血
                            class: `is-plain`,
                            label: `不输血`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadEditCustomUsedBloodView2`,
                            permission: `default`
                        }]
                    } else if (row.enum_using_blood_status == 1) {
                        return [{
                            class: `is-plain`,
                            label: `完成`,
                            icon: ``,
                            type: `primary`,
                            emit: `endBlood`,
                            permission: `default`
                        }, {
                            class: `is-plain`,
                            label: `结束`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadEditCustomUsedBloodView`,
                            permission: `default`
                        }]
                    } else if (row.enum_using_blood_status == 5) {
                    } else {
                        return [{
                            class: `is-plain`,
                            label: `修改`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadEditCustomUsedBloodView`,
                            permission: `default`
                        }]
                    }
                }
            }])
        },
        customUsedbloodColumns() {
            return [{
                type: `string`,
                prop: `code`,
                label: `血袋号`
            }, {
                type: `select`,
                prop: `dic_blood_id`,
                label: `血液分类`,
                // width:'200',
                options: _.map(this.bloodDic, d => {
                    return {
                        value: d.id,
                        code: d.code,
                        label: d.name,
                        jianpin: d.abbr
                    }
                }),
                change: (that, { row }) => {
                    let r = _.find(this.bloodDic, { id: row.dic_blood_id })
                    row.unit = r && r.unit
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `select`,
                prop: `enum_blood_type`,
                label: `血型`,
                width: `60`,
                options: this.sys_enums.Enum_BloodType || [],
                isListable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `select`,
                prop: `enum_blood_type_rh`,
                label: `RH血型`,
                width: `60`,
                options: this.sys_enums.Enum_RhBloodType || [],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `float`,
                prop: `quantity`,
                label: `血量`,
                width: `60`,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `unit`,
                width: `60`,
                label: `单位`
            }, {
                //   type: "datetime",
                //   prop: "valid_date",
                //   label: "失效时间"
                // },{
                type: `bool`,
                prop: `is_own`,
                label: `自体血`,
                options: `enum_bool`,
                width: `60`,
                default: false
            }]
        },
        checkUsedbloodColumns() {
            return [{
                type: `checkbox`,
                prop: `chk1`,
                label: { content: ` ` },
                colspan: 3
            }, {
                type: `p`,
                prop: `p1`,
                label: { content: ` `, position: `top` },
                colspan: 21
            }, {
                type: `p`,
                prop: `p2`,
                label: { content: ` ` },
                colspan: 24
            }, {
                type: `p`,
                prop: `p3`,
                label: { content: ` ` },
                colspan: 24
            }, {
                type: `p`,
                prop: `p4`,
                label: { content: ` ` },
                colspan: 24
            }, {
                type: `p`,
                prop: `p5`,
                label: { content: ` ` },
                colspan: 24
            }, {
                type: `p`,
                prop: `p6`,
                label: { content: ` ` },
                colspan: 24
            }, {
                type: `select`,
                prop: `dic_worker_id_circuit`,
                label: `巡回护士`,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                colspan: 12,
                options: (this.worker[`护士`] || [])
            }, {
                type: `select`,
                prop: `dic_worker_id_anesthesiologist`,
                label: `麻醉医生`,
                colspan: 12,
                readonly: true,
                // validate: [{required: true, message: '必填项目', trigger: 'blur'}],
                options: this.worker[`医生`] || []
            }, {
                type: `datetime`,
                prop: `check_time`,
                label: `核对时间`,
                default: this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            }]
        },
        editCustomUsedBloodColumns() {
            return [{
                type: `radio`,
                prop: `enum_using_blood_status`,
                label: `输血结果状态`,
                colspan: 24,
                options: this.sys_enums.BloodUsingStatus && _.filter(this.sys_enums.BloodUsingStatus, d => d.value > 1 && d.value < 5) || [],
                default: 2,
                change: (that, { row }) => {
                    if (row.enum_using_blood_status == 2) {
                        row.left_quantity = 0
                    }
                }
            }, {
                type: `datetime`,
                prop: `begin_time`,
                colspan: 12,
                label: `输血开始时间`
            }, {
                type: `datetime`,
                prop: `end_time`,
                colspan: 12,
                label: `输血结束时间`,
                default: this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            }, {
                type: `select`,
                prop: `enum_blood_destination`,
                label: `带入`,
                readonly: (that, { row }) => {
                    return row.enum_using_blood_status == 2
                },
                colspan: 12,
                options: this.sys_enums.Enum_BloodDestination || [],
                isListable: true,
                default: 1
            }, {
                type: `float`,
                prop: `left_quantity`,
                colspan: 8,
                label: `余`,
                readonly: (that, { row }) => {
                    return row.enum_using_blood_status == 2
                },
                default: 0,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `p`,
                prop: `unit`, // 单位
                colspan: 4,
                label: { content: ` `, position: `top` }
            }, {
                type: `string`,
                prop: `remark`,
                label: `补充说明`,
                colspan: 24
            }, {
                type: `select`,
                prop: `dic_worker_id_circuit`,
                label: `操作人`,
                colspan: 12,
                options: (that, { row }) => {
                    return q => {
                        let worker = JSON.parse(JSON.stringify(this.worker[`护士`]))
                        return (worker || []).concat(this.currentUser && [{ value: this.currentUser.dic_worker_id, label: this.currentUser.dic_worker_name }])
                    }
                }
            }]
        },
        editCustomUsedBloodColumns2() {
            return [{
                type: `radio`,
                prop: `enum_using_blood_status`,
                label: `输血结果状态`,
                colspan: 24,
                options: this.sys_enums.BloodUsingStatus && _.filter(this.sys_enums.BloodUsingStatus, d => d.value == 5) || [],
                default: 5
            }, {
                type: `select`,
                prop: `enum_blood_destination`,
                label: `带入`,
                readonly: (that, { row }) => {
                    return row.enum_using_blood_status == 2
                },
                colspan: 12,
                options: this.sys_enums.Enum_BloodDestination || [],
                isListable: true,
                default: 1
            }, {
                type: `string`,
                prop: `remark`,
                label: `补充说明`,
                colspan: 24
            }, {
                type: `select`,
                prop: `dic_worker_id_circuit`,
                label: `操作人`,
                colspan: 12,
                options: (that, { row }) => {
                    return q => {
                        let worker = JSON.parse(JSON.stringify(this.worker[`护士`]))
                        return (worker || []).concat(this.currentUser && [{ value: this.currentUser.dic_worker_id, label: this.currentUser.dic_worker_name }])
                    }
                }
            }]
        }
    },
    methods: {
        Init() {
            if (!this.surgeryId) return
            let req = this.myaxios.get(`/api/Nursing/Blood/GetBySurgery`, { surgeryId: this.surgeryId })
            let req2 = this.myaxios.get(`/api/Nursing/Blood/GetUseDetail?surgeryId=${this.surgeryId}`)
            this.myaxios.all(req, req2).then(([apply, usedbloods]) => {
                this.bloodApplies = apply && apply.map(ap => {
                    let dts = _.find(ap.datas, { Key: `use_blood_reason` })
                    ap.use_blood_reason = dts && dts.Value
                    ap.usedblood = _.filter(usedbloods, udb => ap.id == udb.biz_blood_header_id).map(d => {
                        d.name = d.blood.name
                        d.quantity = `${d.quantity}${d.blood.unit}`
                        d.anesthesiologist = d.anesthesiologist && d.anesthesiologist.name
                        d.circuit = d.circuit && d.circuit.name
                        d.blood_type = `${d.blood_type || `--`}(${d.blood_type_rh || `--`})`
                        return d
                    })
                    return ap
                })

                if (!this.activeName && this.bloodApplies) {
                    this.activeName = this.bloodApplies.length > 0 && this.bloodApplies[0].id
                }
            }).catch(e => {
                console.log(e)
                this.bloodApplies = []
            })
        },
        scanblood() {
            let that = this
            if (!that.bloodno) {
                that.$message.warning(`请输入或扫码`)
            }
            let req = that.myaxios.post(`/api/Nursing/Blood/BloodScan?barcode=${that.bloodno.trim()}&surgeryId=${that.surgeryId}`)
            req.then(data => {
                let req = this.loadSurgery()
                req.then(surgery => {
                    if (data) {
                        this.customUsedblood.data = {
                            enum_blood_type_rh: surgery.visit_info && surgery.visit_info.enum_rh_blood_type,
                            enum_blood_type: surgery.visit_info && surgery.visit_info.enum_blood_type,
                            code: data.code,
                            dic_blood_id: data.blood_id,
                            quantity: data.quantity,
                            unit: data.unit,
                            is_own: data.is_own
                        }
                    } else {
                        this.customUsedblood.data = {
                            enum_blood_type_rh: surgery.visit_info && surgery.visit_info.enum_rh_blood_type,
                            enum_blood_type: surgery.visit_info && surgery.visit_info.enum_blood_type,
                            quantity: 0
                        }
                    }
                    this.customUsedblood.dialogFormVisible = true
                    that.bloodno = ``
                    that.$refs[`scan-code`].scan_val = ``
                    that.$message.success(`扫码成功`)
                })
            }).catch(e => {
                that.$message.error(e)
            })
        },
        loadUseCustom() {
            if (!this.surgeryId) return
            let req = this.myaxios.get(`/api/Nursing/Blood/GetUseCustom`, { surgeryId: this.surgeryId })
            req.then(data => {
                this.customUsedBlood = data && data.map(d => {
                    d.name = d.blood && d.blood.name
                    d.anesthesiologist = d.anesthesiologist && d.anesthesiologist.name
                    d.circuit = d.circuit && d.circuit.name
                    d.blood_type = `${d.blood_type || `--`}(${d.blood_type_rh || `--`})`
                    // d.is_own = d.is_own?"是":"否"
                    return d
                })
            }).catch(e => {
                console.log(e)
            })
        },
        loadSurgery() {
            if (!this.surgeryId) return
            return new Promise((resolve, reject) => {
                if (this.surgeryInfo && this.surgeryInfo.id == this.surgeryId) {
                    resolve(this.surgeryInfo)
                } else {
                    let req1 = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                    req1.then(data => {
                        this.surgeryInfo = data
                        resolve(this.surgeryInfo)
                    }).catch(e => {
                        console.log(e)
                        resolve({})
                    })
                }
            })
        },
        loadBloodDic() {
            let req = this.myaxios.get(`/api/AcisSystem/BloodDic/Get`)
            req.then(data => {
                this.bloodDic = data
            }).catch(e => { console.log(e) })
        },
        loadAdverseReactions() { // 加载不良反应记录单
            if (!this.surgeryId) return
            let req = this.myaxios.get(`/api/Nursing/AdverseReaction/Get?surgeryId=${this.surgeryId}`)
            req.then(data => {
                this.docguid = `不良反应记录单_${this.surgeryId}`
                this.adverse_record = data
                this.adverse.dialogFormVisible = true
                this.$nextTick(() => {
                    this.$refs.doc.loadDocument()
                })
            }).catch(e => console.log(e))
        },
        saveAdverseReactionsDocument() {
            this.$refs.doc.save()
        },
        afterAdverseReactionsDocumentSaved(data) {
            let req
            if (this.adverse_record && this.adverse_record.id) {
                req = this.myaxios.put(`/api/Nursing/AdverseReaction/Put`, {
                    'id': this.adverse_record.id,
                    'biz_surgery_info_id': this.surgeryId,
                    'document_id': this.docguid,
                    'enum_adverse_reaction_type': 1// Enum_AdverseReactionType  1用血
                })
            } else {
                req = this.myaxios.post(`/api/Nursing/AdverseReaction/Post`, {
                    // "id": 0,
                    'biz_surgery_info_id': this.surgeryId,
                    'document_id': this.docguid,
                    'enum_adverse_reaction_type': 1// Enum_AdverseReactionType  1用血
                })
            }
            req.then(data => {
                this.adverse.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        loadNewBloodApply() {
            let req1 = this.loadSurgery()
            req1.then(surgery => {
                this.bloodapply.data = {
                    patient_name: surgery.visit_info.name,
                    age: surgery.visit_info.age,
                    sex: surgery.visit_info.sex,
                    visit_no: surgery.visit_info.visit_no,
                    dic_operating_room: surgery.dic_operating_room,
                    dic_opearting_ward: surgery.dic_opearting_ward,
                    diseases: surgery.fact_diseases && _.map(surgery.fact_diseases, d => d.label).toString() || (surgery.plan_diseases && _.map(surgery.plan_diseases, d => d.label).toString()),
                    blood_p15: ``,
                    enum_blood_type_rh: surgery.visit_info.enum_rh_blood_type,
                    enum_blood_type: surgery.visit_info.enum_blood_type,
                    null_1: ` `,
                    enum_use_blood_type: 1,
                    Hb: 0,
                    HCT: 0,
                    PLT: 0,
                    HBsAg: undefined,
                    Anti_HCV: undefined,
                    Anti_HV: undefined,
                    MD: undefined
                    // datas:{
                    //   Hb:0,HCT:0,PLT:0,HBsAg:undefined,Anti_HCV:undefined,Anti_HV:undefined,MD:undefined
                    // }
                }
                this.openData = this.bloodapply.data
                this.bloodapply.dialogFormVisible = true
            }).catch(e => { console.log(e) })
        // this.$nextTick(()=>{
        //   this.$refs.doc2.loadDocument()
        // })
        },
        loadEditBloodApply(id) {
            let req1 = this.myaxios.get(`/api/Nursing/Blood/Get/${id}`)
            let req2 = this.loadSurgery()
            this.myaxios.all(req1, req2).then(([applay, surgery]) => {
                let datas = _.reduce(applay.datas, function(result, value, index) {
                    result[value.Key] = value.Value
                    return result
                }, {})
                this.bloodapply.data = Object.assign({
                    patient_name: surgery.visit_info.name,
                    age: surgery.visit_info.age,
                    sex: surgery.visit_info.sex,
                    visit_no: surgery.visit_info.visit_no,
                    dic_operating_room: surgery.dic_operating_room,
                    dic_opearting_ward: surgery.dic_opearting_ward,
                    diseases: surgery.fact_diseases && _.map(surgery.fact_diseases, d => d.label).toString() || (surgery.plan_diseases && _.map(surgery.plan_diseases, d => d.label).toString()),
                    last_date: datas.last_date,
                    yzs: { y: datas.yzs_y, c: datas.yzs_c },
                    blood_p15: datas.blood_p15 || ``,
                    null_1: `  `,
                    history_blood: datas.history_blood,
                    reaction_blood: datas.reaction_blood,
                    // enum_blood_type_rh:surgery.visit_info.enum_rh_blood_type,
                    // enum_blood_type:surgery.visit_info.enum_blood_type,
                    use_blood_reason: datas.use_blood_reason
                }, applay, {
                    Hb: datas.Hb, HCT: datas.HCT, PLT: datas.PLT, HBsAg: datas.HBsAg, Anti_HCV: datas.Anti_HCV, Anti_HV: datas.Anti_HV, MD: datas.MD
                    // datas:{
                    //   Hb:datas.Hb,HCT:datas.HCT,PLT:datas.PLT,HBsAg:datas.HBsAg,Anti_HCV:datas.Anti_HCV,Anti_HV:datas.Anti_HV,MD:datas.MD
                    // }
                })
                this.openData = this.bloodapply.data
                this.bloodapply.dialogFormVisible = true
            })
        },
        deleteBloodApply(id) {
            let that = this
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = that.myaxios.delete(`/api/Nursing/Blood/Delete/${id}`)
                req.then(data => {
                    let odlapindex = _.findIndex(this.bloodApplies, { id: id })
                    this.bloodApplies.splice(odlapindex, 1)
                // that.Init()
                }).catch(e => { console.log(e) })
            })
        },
        generateUUID() {
            var d = new Date().getTime()
            var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16) % 16 | 0
                d = Math.floor(d / 16)
                return (c == `x` ? r : (r & 0x3 | 0x8)).toString(16)
            })
            return uuid
        },
        SaveBloodApply(row) {
            if (row.yzs && row.yzs.y < row.yzs.c) {
                this.$message.warning(`产值不能大于孕值`)
                return
            }
            let valid = true
            let data = {
                'id': row.id,
                'biz_surgery_info_id': this.surgeryId,
                'enum_blood_type': row.enum_blood_type,
                'enum_blood_type_rh': row.enum_blood_type_rh,
                'enum_use_blood_type': row.enum_use_blood_type,
                'apply_date': row.apply_date,
                'document_id': this.docbizid,
                'execute_date': row.execute_date,
                'enum_blood_status': 0,
                'datas': [{
                    key: `Hb`, value: row.Hb || ``
                }, {
                    key: `HCT`, value: row.HCT || ``
                }, {
                    key: `PLT`, value: row.PLT || ``
                }, {
                    key: `HBsAg`, value: row.HBsAg || ``
                }, {
                    key: `Anti_HCV`, value: row.Anti_HCV || ``
                }, {
                    key: `Anti_HV`, value: row.Anti_HV || ``
                }, {
                    key: `MD`, value: row.MD || ``
                }, {
                    key: `last_date`, value: row.last_date || ``
                }, {
                    key: `yzs_y`, value: row.yzs && row.yzs.y || ``
                }, {
                    key: `yzs_c`, value: row.yzs && row.yzs.c || ``
                }, {
                    key: `blood_p15`, value: row.blood_p15 && row.blood_p15.toString() || ``
                }, {
                    key: `history_blood`, value: row.history_blood || ``
                }, {
                    key: `reaction_blood`, value: row.reaction_blood || ``
                }, {
                    key: `use_blood_reason`, value: row.use_blood_reason || ``
                }],
                // "datas":_.reduce(row.datas, function(result, value, key) {
                //   result.push({key:key,value:value||''})
                //   return result
                // }, []).concat(),
                'application_list': _.filter(row.application_list, d => { return d.id > 0 }).map(d => {
                    // let bd= _.find(this.bloodDic,{id:d.id})
                    if (d.quantity <= 0 && valid) {
                        valid = false
                    }
                    return {
                        id: d.id,
                        // code:bd&&bd.code,
                        // name:bd.name,
                        quantity: d.quantity
                    }
                })
            }
            if (!valid || data.application_list.length == 0) {
                this.$message.warning(`申请输血量不能为0`)
                return
            }
            if (row.id) {
                let req = this.myaxios.put(`/api/Nursing/Blood/Put`, data)
                req.then(data => {
                    this.Init()
                    this.bloodapply.dialogFormVisible = false
                }).catch(e => {
                    console.log(e)
                })
            } else {
                let req = this.myaxios.post(`/api/Nursing/Blood/Post`, data)
                req.then(data => {
                    this.bloodapply.dialogFormVisible = false
                    this.Init()
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        loadUseDetail(id) {
            let odlap = _.find(this.bloodApplies, { id: id })
            let req = this.myaxios.get(`/api/Nursing/Blood/GetUseDetail?surgeryId=${odlap.biz_surgery_info_id}`)
            req.then(data => {
                let r = _.filter(data, { biz_blood_header_id: id })
                this.$set(odlap, `usedblood`, _.map(r, d => {
                    d.name = d.blood.name
                    d.quantity = `${d.quantity}${d.blood.unit}`
                    d.anesthesiologist = d.anesthesiologist && d.anesthesiologist.name
                    d.circuit = d.circuit && d.circuit.name
                    return d
                }))
            }).catch(e => { console.log(e) })
        },
        // loadCurrentSupplyBloods($event){
        // if($event === undefined) return
        // if($event.length>this.openItem.length){
        //   let id = _.difference($event,this.openItem)[0]
        //   if(id>-1) {
        //     this.loadUseDetail(id)
        //   }
        // }
        // this.openItem = [...$event]
        // },
        loadNewCustomUseBloodView() {
            let req = this.loadSurgery()
            req.then(surgery => {
                this.customUsedblood.data = {
                    quantity: 0,
                    enum_blood_type_rh: surgery.visit_info && surgery.visit_info.enum_rh_blood_type,
                    enum_blood_type: surgery.visit_info && surgery.visit_info.enum_blood_type
                }
                this.customUsedblood.dialogFormVisible = true
            })
        },
        loadEditCustomUseBloodView({ row }) {
            row.unit = row.blood.unit
            this.customUsedblood.data = row
            this.customUsedblood.dialogFormVisible = true
        },
        deleteCustomUseBlood({ row }) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`/api/Nursing/Blood/DeleteCustom/${row.id}`)
                req.then(data => {
                    this.loadUseCustom()
                }).catch(e => { console.log(e) })
            })
        },
        SaveCustomUsedBlood(row) {
            if (!row.dic_blood_id) {
                this.$message.warning(`血液种类必填`)
                return
            }
            let req
            if (row.id && row.id > 0) {
                req = this.myaxios.put(`/api/Nursing/Blood/PutCustom`, {
                    'id': row.id,
                    // "biz_blood_header_id":this.pullBlood.data.id,//血液申请id
                    'biz_surgery_info_id': this.surgeryId,
                    'dic_blood_id': row.dic_blood_id,
                    'quantity': row.quantity,
                    'code': row.code,
                    'enum_using_blood_status': row.enum_using_blood_status,
                    // "modifier": "string",
                    // "enum_using_blood_status": 0,
                    'enum_blood_type': row.enum_blood_type,
                    'enum_blood_type_rh': row.enum_blood_type_rh,
                    'valid_date': row.valid_date,
                    'check_time': row.check_time,
                    'is_own': row.is_own,
                    'blood': {
                        'id': row.dic_blood_id
                    }
                })
            } else {
                req = this.myaxios.post(`/api/Nursing/Blood/PostCustom`, {
                    'id': row.id,
                    // "biz_blood_header_id":this.pullBlood.data.id,//血液申请id
                    'biz_surgery_info_id': this.surgeryId,
                    'dic_blood_id': row.dic_blood_id,
                    'quantity': row.quantity,
                    'code': row.code,
                    'enum_using_blood_status': 0,
                    // "modifier": "string",
                    // "enum_using_blood_status": 0,
                    'enum_blood_type': row.enum_blood_type,
                    'enum_blood_type_rh': row.enum_blood_type_rh,
                    'valid_date': row.valid_date,
                    'check_time': row.check_time,
                    'is_own': row.is_own,
                    'blood': {
                        'id': row.dic_blood_id
                    }
                })
            }

            req.then(data => {
                this.Init()
                this.loadUseCustom()
                this.customUsedblood.dialogFormVisible = false
            }).catch(e => { console.log(e) })
        },
        ExtraButtonClick(target, type) {
            this.type = type
            this[target.emit] && this[target.emit](target)
        },
        loadCheckBloodView({ row }) {
            this.loadSurgery().then(info => {
                this.checkbloodview.data = {
                    chk1: false,
                    p1: `以下核对均通过`,
                    p2: `1.核对患者腕带信息：床号、姓名、${this.T(`blood_apply.visit_no`)}`,
                    p3: `2.核对交叉配血报告单上各项内容：受血者姓名、${this.T(`blood_apply.visit_no`)}、科别、床号、年龄、性别、血型(包括Rh因子)、血液成分、剂量、交叉配血报告单上无凝集反应`,
                    p4: `3.核对血袋标签：献血者与受血者血型(包括Rh因子)、血袋号(条形码)、血液成分、有效期`,
                    p5: `4.血袋有无破损渗漏、有无溶血及凝块、输血装置是否完好`,
                    p6: `5.核实血型报告单(与病史中血型报告单核对)`,
                    dic_worker_id_circuit: info.fact_circuit_nurse && info.fact_circuit_nurse[0] && info.fact_circuit_nurse[0].value || (info.plan_circuit_nurse && info.plan_circuit_nurse[0] && info.plan_circuit_nurse[0].value),
                    dic_worker_id_anesthesiologist: info.fact_anes_doctor && info.fact_anes_doctor.value || (info.plan_anes_doctor && info.plan_anes_doctor.value),
                    biz_blood_header_id: row.biz_blood_header_id,
                    check_time: this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
                }
                this.checkbloodview.usedblood = row
                this.checkbloodview.dialogFormVisible = true
            })
        },
        SaveUsedBlood(row) {
            if (!row.chk1) {
                this.$message.warning(`请确认核对通过`)
                return
            }
            let data = { ...this.checkbloodview.usedblood }
            data.check_time = row.check_time
            data.dic_worker_id_circuit = row.dic_worker_id_circuit
            data.dic_worker_id_anesthesiologist = row.dic_worker_id_anesthesiologist
            data.enum_using_blood_status = 0
            let req
            if (this.type == 2) {
                req = this.myaxios.put(`/api/Nursing/Blood/PutCustom`, data)
            } else {
                req = this.myaxios.put(`/api/Nursing/Blood/PutUseBlood`, data)
            }
            req.then(data => {
                if (row.biz_blood_header_id) {
                    this.loadUseDetail(row.biz_blood_header_id)
                } else {
                    this.loadUseCustom()
                }
                this.checkbloodview.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        startBlood({ row }) {
            let data = { ...row }
            data.begin_time = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            data.enum_using_blood_status = 1 // BloodUsingStatus  1 输血中
            let req
            if (this.type == 2) {
                req = this.myaxios.put(`/api/Nursing/Blood/PutCustom`, data)
            } else {
                req = this.myaxios.put(`/api/Nursing/Blood/PutUseBlood`, data)
            }
            req.then(data => {
                if (row.biz_blood_header_id) {
                    this.loadUseDetail(row.biz_blood_header_id)
                } else {
                    this.loadUseCustom()
                }
            }).catch(e => console.log(e))
        },
        endBlood({ row }) {
            let data = { ...row }
            data.end_time = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            data.enum_using_blood_status = 2 // BloodUsingStatus  2 输注完成
            let req
            if (this.type == 2) {
                req = this.myaxios.put(`/api/Nursing/Blood/PutCustom`, data)
            } else {
                req = this.myaxios.put(`/api/Nursing/Blood/PutUseBlood`, data)
            }
            req.then(data => {
                if (row.biz_blood_header_id) {
                    this.loadUseDetail(row.biz_blood_header_id)
                } else {
                    this.loadUseCustom()
                }
            }).catch(e => console.log(e))
        },
        loadEditCustomUsedBloodView({ row }) {
            let data = { ...row }
            data.unit = data.blood.unit
            data.enum_using_blood_status = data.enum_using_blood_status === 1 ? 2 : data.enum_using_blood_status || 2
            data.begin_time = row.begin_time
            data.end_time = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            data.biz_blood_header_id = row.biz_blood_header_id
            data.dic_worker_id_circuit = this.currentUser.dic_worker_id
            data.left_quantity = row.left_quantity

            this.editCustomUsedBloodView.data = data
            this.editCustomUsedBloodView.dialogFormVisible = true
        },
        loadEditCustomUsedBloodView2({ row }) {
            let data = { ...row }
            data.unit = data.blood.unit
            data.enum_using_blood_status = data.enum_using_blood_status || 5
            data.begin_time = row.begin_time
            data.end_time = row.end_time
            data.biz_blood_header_id = row.biz_blood_header_id
            data.dic_worker_id_circuit = this.currentUser.dic_worker_id
            data.left_quantity = row.left_quantity

            this.editCustomUsedBloodView2.data = data
            this.editCustomUsedBloodView2.dialogFormVisible = true
        },
        saveEndUsedBlood(row) {
            let data = { ...row }
            let req
            if (this.type == 2) {
                req = this.myaxios.put(`/api/Nursing/Blood/PutCustom`, data)
            } else {
                req = this.myaxios.put(`/api/Nursing/Blood/PutUseBlood`, data)
            }
            req.then(data => {
                if (row.biz_blood_header_id) {
                    this.loadUseDetail(row.biz_blood_header_id)
                } else {
                    this.loadUseCustom()
                }
                this.editCustomUsedBloodView.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        saveNotUsedBlood(row) {
            let data = { ...row }
            let req
            if (this.type == 2) {
                req = this.myaxios.put(`/api/Nursing/Blood/PutCustom`, data)
            } else {
                req = this.myaxios.put(`/api/Nursing/Blood/PutUseBlood`, data)
            }
            req.then(data => {
                if (row.biz_blood_header_id) {
                    this.loadUseDetail(row.biz_blood_header_id)
                } else {
                    this.loadUseCustom()
                }
                this.editCustomUsedBloodView2.dialogFormVisible = false
            }).catch(e => console.log(e))
        },
        submitBloodApply(item) {
            let req = this.myaxios.put(`/api/Nursing/Blood/Put`, { id: item.id, enum_blood_status: 1 })
            req.then(data => {
                this.$message.success(`已提交`)
                this.Init()
                this.loadUseCustom()
            // this.loadUseDetail(item.id)
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            // this.openItem=[]
            this.Init()
            this.loadUseCustom()
            this.activeName = undefined
        }
    }
}
</script>
<style lang="less">
.el-collapse-item [role='button'] {
    background: whitesmoke !important;
}
.dialog-adverse .el-dialog__body {
    padding: 0 !important;
}
</style>
<style scoped lang="less">
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Blood/Apply.vue